export enum Currencies {
  USD = 'USD',
  CAD = 'CAD',
}
